export default __webpack_public_path__ + "static/media/delete-red.6d5c307a.svg";